import { VFC } from 'react'
import { FOOTER_ARROW } from 'src/assets/images'
import { Link } from 'src/elements/Link'
import { _menuhover, floralwhite, lightgray } from 'src/styles/colors'
import { fontWeightBold, fontWeightRegular } from 'src/styles/font'
import {
  APP_LP_URL,
  ARTICLES,
  CHIRA_CEO_CASE_URL,
  CHIRA_CEO_URL,
  COMPANY,
  CONTACT,
  EVENTS_URL,
  HIRING_URL,
  NOTE_URL,
  PRIVACY,
  SECURITY,
  TERMS,
} from 'src/utils/routes'
import styled from 'styled-components'

export const GuestFooter: VFC = () => (
  <footer>
    <Navigation>
      <Column>
        <h3>サービス概要</h3>
        <FooterLink
          href={APP_LP_URL}
          label="決裁者のための経営相談・発注先探しサービス「ONLYSTORY」"
        />
        <FooterLink
          href={CHIRA_CEO_URL}
          label="決裁者限定マッチングプラットフォーム「チラCEO」"
        />
        <FooterLink href={EVENTS_URL} label="会員様限定イベント" />
        <FooterLink href={CHIRA_CEO_CASE_URL} label="利用したお客様からの声" />
      </Column>
      <Column>
        <h3>運営会社</h3>
        <FooterLink href={COMPANY} label="会社概要" />
        <FooterLink href={HIRING_URL} label="採用情報" />
        <FooterLink href={NOTE_URL} label="代表平野のnote一覧" />
        <FooterLink href={ARTICLES} label="お知らせ" />
      </Column>
      <Column>
        <FacebookIframe src="//www.facebook.com/plugins/likebox.php?href=https%3A%2F%2Fwww.facebook.com%2Fchushokigyo&width=350&height=200&colorscheme=light&show_faces=true&header=true&stream=false&show_border=true&appId=596973943671943" />
      </Column>
    </Navigation>
    <BottomDiv>
      <div>
        <Link href={COMPANY}>運営会社</Link>
        {' | '}
        <Link href={HIRING_URL}>求人情報</Link>
        {' | '}
        <Link href={TERMS}>利用規約</Link>
        {' | '}
        <Link href={PRIVACY}>プライバシーポリシー</Link>
        {' | '}
        <Link href={SECURITY}>情報セキュリティ方針</Link>
        {' | '}
        <Link href={CONTACT}>お問い合わせ</Link>
      </div>
      <Copyright>Copyright@ONLY STORY.inc All rights Reserved</Copyright>
    </BottomDiv>
  </footer>
)
const FooterLink: VFC<{ href: string; label: string }> = ({ href, label }) => (
  <StyledFooterLink href={href}>
    <img src={FOOTER_ARROW} alt="" />
    {label}
  </StyledFooterLink>
)
const BottomDiv = styled.div`
  color: ${lightgray};
  margin: auto;
  text-align: center;
  padding: 15px;
  word-break: keep-all;
`
const Navigation = styled.nav`
  display: flex;
  justify-content: center;
  background-color: ${floralwhite};
  padding: 15px 0;

  @media screen and (max-width: 1023px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`
const FacebookIframe = styled.iframe`
  max-width: 350px;
  flex: 1;
  margin: auto;
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 15px 28px;
  h3 {
    font-size: 19px;
    font-weight: ${fontWeightBold};
    margin-top: 19px;
    margin-bottom: 12px;
  }
`
const StyledFooterLink = styled(Link)`
  padding-left: 30px;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: ${fontWeightRegular};
  :hover {
    text-decoration: underline;
    color: ${_menuhover};
  }
  img {
    height: 1em;
    margin-right: 5px;
    vertical-align: text-top;
  }
`

const Copyright = styled.p`
  margin-top: 15px;
  text-align: center;
`
